module.exports = "/_next/static/images/la-abeeee00d7384ff103fac58a457557a3.svg";